import React from "react";
import { MimaText, Modal } from "../../../components";

const ViewMoreAds = ({ item, closeModal }) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText
        variant="subtitleBold"
        align="center"
        mb={5}
      >{`${item.moneyExUser.username}'s Account Info`}</MimaText>
      <div>
        <MimaText labelTitle="Account name" mb={2}>
          {item.bankInfo.accountName}
        </MimaText>
        <MimaText labelTitle="Account number" mb={2}>
          {item.bankInfo.accountNumber}
        </MimaText>
        <MimaText labelTitle="Bank name" mb={2}>
          {item.bankInfo.bank}
        </MimaText>
        <MimaText labelTitle="Account Type" mb={2}>
          {item.bankInfo.accountType}
        </MimaText>
        <MimaText labelTitle="Account currency" mb={2}>
          {item.bankInfo.currencyCode}
        </MimaText>
      </div>
    </Modal>
  );
};
export default ViewMoreAds;
